// src/components/ContactWidget.jsx
import React, { useState, useEffect, useRef } from 'react';
import { FaCommentDots, FaTimes } from 'react-icons/fa';
import '../styles/ContactWidget.css';

const ContactWidget = () => {
  const [open, setOpen] = useState(false);
  const popRef       = useRef(null);
  const btnRef       = useRef(null);

  /* --- закрытие кликом вне виджета --- */
  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (
        popRef.current  && !popRef.current.contains(e.target) &&
        btnRef.current  && !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    window.addEventListener('mousedown', handleClick);
    return () => window.removeEventListener('mousedown', handleClick);
  }, [open]);

  /* --- закрытие Esc --- */
  useEffect(() => {
    if (!open) return;
    const handleEsc = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [open]);

  return (
    <>
      {/* ------ плавающая кнопка ------ */}
      <button
        className="cw-btn"
        ref={btnRef}
        aria-label="Контакты"
        onClick={() => setOpen(prev => !prev)}
      >
        {open ? <FaTimes size={20}/> : <FaCommentDots size={20}/>}
      </button>

      {/* ------ всплывашка ------ */}
      {open && (
        <div className="cw-popup" ref={popRef}>
          <a
            href="https://t.me/Reservecar_ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            💬 Написать в Telegram
          </a>
          <a href="tel:+79062699994">
            📞 +7 (906) 269-99-94
          </a>
        </div>
      )}
    </>
  );
};

export default ContactWidget;
